import { diffWordsWithSpace, type Change } from 'diff';

export type TextDiffPart = Change;

/** Word-level diff between two strings, preserving exact whitespace/newlines — used to
 * highlight what actually changed inline within a long text field (a TDD section body, a PRD
 * problem statement, ...) instead of showing two full before/after blocks and making the reader
 * spot the difference themselves. */
export function diffText(before: string, after: string): TextDiffPart[] {
  return diffWordsWithSpace(before, after);
}
